function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

export default function() {
  return this.eachAfter(count);
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-hierarchy/src/hierarchy/count.js
// module id = ../../../../d3-hierarchy/src/hierarchy/count.js
// module chunks = 4